import React from 'react';
import NavBar from './NavBar.jsx';
import Explore from './Explore.jsx'
//import {ExploreMap} from './ExploreMap.jsx'
import Login from './Login.jsx'
import Admin from './Admin.jsx'
import Logout from './LogOut.jsx'
import Ajax from "./AJAX.jsx";
import * as networkTools from "./networkTools.jsx";
import * as tools from "./tools.jsx";
import {CSSTransitionGroup} from 'react-transition-group'; // ES6
import styles from './../styles/main.css';
import ModalPopUp from './ModalPopUp.jsx';
import * as visualAssets from './visualAssets.jsx';

import {Information} from "./webpages/information.jsx";

import {Oplevelse} from "./webpages/oplevelse.jsx";
import * as webpageStyles from "./webpages/webpageStyles.jsx"
import {MessageModal} from "./MessageModal.jsx";

//Redux stuff
import {connect, Provider} from "react-redux";
import store from "./stateStuff/store";

//import BottomPageElem from './BottomPageElem.jsx';
//Setup App Top Nav Bar

var navBarBtns =  [
         {id:"info", name:"INFORMATION"},
         {id:"oplev", name:"OPLEVELSE"},
         {id:"map", name:"LYDLANDKORT"},
         {id:"admin", name:"ADMIN"},
         {id:"login", name:"", floatRight:true},
         {id:"logout", name:"LOG OUT", floatRight:true}
         ];

const stdBarElems = [ 'info', 'oplev', 'map', 'admin', 'login', 'logout'];

var navBarBtnsForPages =  {
         info:[...stdBarElems],
         oplev:[...stdBarElems],
         map:[...stdBarElems],
         admin: [...stdBarElems, 'admin', 'logout'],
         login:[...stdBarElems, 'login']
      };
//Objects visible only when logged in
var navBarBtnsReqLogin = new Set();
navBarBtnsReqLogin.add('logout');
navBarBtnsReqLogin.add('admin');

//Objects visible only when logged out
var navBarBtnsReqLogout = new Set();
navBarBtnsReqLogout.add('login');


window.mobilecheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

class App extends React.Component {


   

   constructor()
   {
      super();
      this.state ={
         page:"",
         user:null,
         isLoggedIn:false,
         modals:[],
         errorMsgs:[],
         compositions:[],
         showMustUpdate:false,
      }

      this.appCallbacks = new Object();

      this.appCallbacks.pushModal = function(jsxModal)
      {
         const updateStateFunc = (prevState, props)=>
         {
            const newModals = [...prevState.modals, jsxModal];
            return {modals:newModals};
         }

         this.setState(updateStateFunc);

      }.bind(this);

      this.appCallbacks.popModal = function()
      {
         const updateStateFunc = (prevState, props)=>
         {
            const newModals = prevState.modals.slice(0, prevState.modals.length - 1);
            return {modals:newModals};
         }

         this.setState(updateStateFunc);
      }.bind(this);


      this.appCallbacks.changePageCallback = function(newPage)
      {
         this.setState({page:newPage});
      }.bind(this);


      this.appCallbacks.performAjaxRequest = function(url, method, params, callback, paramsIsFile)
      {
         const onComplete = (responseObj)=>
         {
            var loginChanged = this.state.isLoggedIn != responseObj.isLoggedIn;

            this.setState({user:responseObj.user});
            //console.log("Setting logged in to: " + responseObj.isLoggedIn);
            this.setState({isLoggedIn:responseObj.isLoggedIn});

            var newErrs = this.state.errorMsgs;

            for(var e in responseObj.error)
            {
               newErrs.push(responseObj.error[e]);
               console.log("Got error: " + responseObj.error[e], responseObj);
            }

            if(responseObj.error.length > 0)
            {
               this.setState({errorMsgs:newErrs});
               console.log("Errorneous response object:");
               console.log(responseObj);
            }
            
            if(!this.state.isLoggedIn && navBarBtnsReqLogin.has(this.state.page))
            {
               console.log("Go to login from App");
               this.appCallbacks.changePageCallback('login');
               return;
            }
 
            //Call callback if no rediretion has occured
            if(callback)
               callback(responseObj);

         }
         networkTools.performAjaxRequest(globalLydfeltAPIPath + url, method, params, onComplete, paramsIsFile);

        
      }.bind(this);

      this.appCallbacks.showMsg = function(heading, msg)
      {
         const foreignKeyMsgPrefix = "Maybe you tried to delete something, that is referenced elsewhere.\n" + 
         "Could be:\nDeleting a context that still has compositions or playlists\nor\n" +
         "Deleting a user, that still has compositions.\n";

         const newMsg = msg.search("foreign key constraint fails") != -1 ? foreignKeyMsgPrefix + msg : msg;

         var modalProps = {
            popModal:this.appCallbacks.popModal,
            heading: heading,
            msg: newMsg,
         };
         this.appCallbacks.pushModal({modalClass:MessageModal, modalProps:modalProps});
      }.bind(this);

      this.appCallbacks.showResponseErr = function(response, heading="API Response")
      {
         const err = tools.getErrorString(response);
         this.appCallbacks.showMsg(heading, err);
      }.bind(this);
   }

   componentDidMount()
   {
      self = this;
      const reactToResize = () =>
      {
         console.log("inner width: " + window.innerWidth + " inner height: " + window.innerHeight);
      }
      window.addEventListener("resize", reactToResize);

      //this.appCallbacks.performAjaxRequest("currentUser", "GET", null, ()=>{}, false);

      this.appCallbacks.performAjaxRequest("compositions", "GET", null, tools.getSetBaseDataFunc(this, "compositions", "errorMsgs"), false);

      this.appCallbacks.changePageCallback('info');

      const checkWebVersion = (response) =>
      {
         if(response.success)
         {
            const newestVersion = response.result.newestWebVersion;
            if(newestVersion != webVersion)
            {
               self.setState({showMustUpdate:true})
            }
            console.log("response", response);
         }
      }
       this.appCallbacks.performAjaxRequest("entityRevisions", "GET", null, checkWebVersion, false);

      //this.appCallbacks.changePageCallback('admin');
      //this.appCallbacks.changePageCallback('map');
   }
   
   render() {
      //Setup Navbar
         var navBarState = new Object();
         navBarState.currentBtn = this.state.page;
   
         navBarState.visibleBtns = new Set();
            
         //console.log("Rendering app with logged in: " + this.state.isLoggedIn);
         var navBarBtnsForThisPage = navBarBtnsForPages[this.state.page];

         if(navBarBtnsForThisPage)
         {
            //Add visible buttons to navbar
            for(var i = 0; i < navBarBtnsForThisPage.length; i++)
            {
               var btn = navBarBtnsForThisPage[i];

               var add = true;
               if(navBarBtnsReqLogin.has(btn) && !this.state.isLoggedIn)
               {
                  add = false;
               }
               if(navBarBtnsReqLogout.has(btn) && this.state.isLoggedIn)
               {
                  add = false;
               }
               
               if(add)
                  navBarState.visibleBtns.add(btn)
            }
         }
      const modalsExist = this.state.modals != null && this.state.modals.length > 0;
      const lastModalIndex = modalsExist ? (this.state.modals.length - 1) : -1;
      const backgroundColor = "#646463";
      const middleContainer =
      {
         backgroundColor:"#FFFFFF",
         position:"relative",
         display:"block",
         width:"100vw",
         margin:"auto",
         maxWidth:1016,
         //height:"100vh",
         opacity:1,
         zIndex:10
         //height:"38.3vw",
         //backgroundSize: "contain",

      }
      const headerContainer = {
         position:"relative",
         display:"block",
         width:"100%",
         height:"40vw",
         maxWidth:1016,
         maxHeight:1016 * 0.40,
         backgroundColor:backgroundColor,
         //border: "1px solid blue",
      }
      
      const headerTopSpacer =
      {
         height:"2vw",
         maxHeight: 1016 * 0.02,
      }

      const headerImg =
      {
         position:"relative",
         backgroundImage:visualAssets.soundmapHeaderLogoTitleURL,
         display:"block",
         width:"92.8vw",
         //height:"33vw",
         height:"100%",
         maxWidth:951,
         //maxHeight:951 * 0.4,
         backgroundSize: "contain",
         backgroundRepeat:"no-repeat",
         margin:"auto",
         //border: "1px solid red",
      }
      const navBarContainer =
      {
         position:"absolute",
         bottom:0,
         height:"20%",
         maxHeight:68,
         width:"100%",
         //border: "1px solid red",
         backgroundImage:visualAssets.soundmapHeaderHorLinesURL,
         backgroundSize: "100% 100%",
         backgroundRepeat:"no-repeat",
         backgroundPosition:"bottom",
      }


      const navBarInnerContainer =
      {
         margin:"auto",
         marginTop:"3%",
         height:"80%",
         width:"93%",
         //border: "1px solid green",
      }

      const mustUpdateStyle = {
         position:"absolute",
         height:50,
         top:0, right:0, left:0,
         backgroundColor:"red",
         zIndex:200,
         color:"white",
         opacity:0.7,
      }
      //console.log("Render!");
      const self = this;
      return (
         <Provider store={store}>
         <div style={{position:"relative", backgroundColor:backgroundColor, minHeight:"100vh", width:"100vw"}} className="hans">
         {this.state.showMustUpdate ? <div style={mustUpdateStyle}>
            Du kører en forældet version af Soundmap.<br/>Gennemtving fuld reload af siden eller slet browserdata for at køre nyeste version.
            <button type="button" onClick={()=>{self.setState({showMustUpdate:false})}}>Forstået!</button>
         </div> : null}
            <div style={middleContainer}>
               <div style={headerContainer}>
                  <div style={headerTopSpacer}/>
                  <div style={headerImg}/>
                  <div style={navBarContainer}>
                     <div style={navBarInnerContainer}>
                        {<NavBar
                           btns = {navBarBtns}
                           appCallbacks = {this.appCallbacks}
                           navBarState={navBarState}/>}
                     </div>
                  </div>
               </div>
               {this.state.page == "info" ? <Information /> : null }
               {this.state.page == "oplev" ? <Oplevelse goToMap={()=>this.appCallbacks.changePageCallback('map')}/> : null }
               {this.state.page != "map" ? null :
               <Explore user={this.state.user} compositions={this.state.compositions}
                  appCallbacks = {this.appCallbacks} /> }
               
               {this.state.page != "login" ? null :
               <Login
                  appCallbacks = {this.appCallbacks} /> }

               {this.state.page != "logout" ? null :
               <Logout
                  appCallbacks = {this.appCallbacks} /> }
               
               {this.state.page == "admin" && this.state.user ?
               <Admin user={this.state.user}
                  appCallbacks = {this.appCallbacks} /> : null}
               
               <div style={{clear:"both"}}/>
               <div style={webpageStyles.footer}>
               <p className={"footer"}>SOUNDMAP.DK • EPOST@SYDOW.DK / RESONANCE.DK • KD@KOMPONISTFORENINGEN.DK / KOMPONISTFORENINGEN.DK</p>
               </div>
            <div style={{width:"100%"}}/>

            
               <ModalPopUp isOpen={modalsExist}
               className="modalPopupOuter"
                   transitionName="modal-anim"
                   appCallbacks = {this.appCallbacks}>
                   
                   {this.state.modals.map((modal, i)=>{
                     var Modal = modal.modalClass;
                     //console.log("Modal i: " + i + ". lastIndex: " + lastModalIndex);
                     return (
                        <div key={i} style={{display:(i == lastModalIndex) ? "block" : "none"}}> //Make only the frontmost modal visible
                           <Modal {...modal.modalProps} />
                        </div>);
                     })}
               </ModalPopUp>
               



              {/*<BottomPageElem errMsgs={this.state.errorMsgs}
                          transitionName="modal-anim"/>*/}  

            </div>
         </div>
         </Provider>
      );
   }
}

export default App;

var lastStatePrinted = {};

let unsubscribe = store.subscribe(() =>
{ 
  const newState = store.getState();


  if(lastStatePrinted != newState)
  {
    //customLog("playback: " + newState.tempData.create.playbackPositions[0] + " and state: ", newState);
    //console.log("state: ", newState);
  }

  lastStatePrinted = newState;

});



// WEBPACK FOOTER //
// ./js/App.jsx